import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { throwError as observableThrowError, Subscriber } from "rxjs";
import { VoceClassificaVO } from "../vo/voce-classificaVO";
import { Observable } from "rxjs";
import { env } from "@env/environment";
import { FiltroRicercaClassificaDTO } from "../dto/filto-ricerca-classificaDTO";
import { VoceClassificaDTO } from "../dto/voce-classificaDTO";
import { MapperVoceClassifica } from "../mapper/mapper-voce-classifica";
import { map, catchError } from "rxjs/operators";
import { ClassificaDTO } from "../dto/classificaDTO";
import { MapperClassifica } from "../mapper/mapper-classifica";
import { ClassificaVO } from "../vo/classificaVO";
import { ModaleErroreStore } from "../store/modale-errore.store";

@Injectable({
  providedIn: "root",
})
export class ClassificaService {
  constructor(
    private httpClient: HttpClient,
    private mapperVoceClassifica: MapperVoceClassifica,
    private modaleErroreStore: ModaleErroreStore,
    private mapperClassifica: MapperClassifica
  ) {}

  getClassificaChildren(codice: string): Observable<VoceClassificaVO[]> {
    const url =
      env.LINNEO_API_URL_BASE + env.LINNEO_CLASSIFICA_BY_CODICE_ESTESO;

    const filtroDTO = new FiltroRicercaClassificaDTO();
    filtroDTO.cmu = codice;
    filtroDTO.exactMatch = false;
    filtroDTO.countChildren = null;
    filtroDTO.showCancellati = false;
    filtroDTO.dataInferiore = null;
    filtroDTO.dataSuperiore = null;

    console.log(
      "[ClassificaServiceComponent][getClassificaChildren] filtroDTO:",
      filtroDTO
    );
    console.log(
      "[ClassificaServiceComponent][getClassificaChildren] url:",
      url
    );

    return this.httpClient
      .post(url, filtroDTO)
      .map((resultList: VoceClassificaDTO[]) =>
        this.mapperVoceClassifica.convertListDtoToVo(resultList)
      );
  }

  async getClassificaChildrenAsync(
    codice: string
  ): Promise<VoceClassificaVO[]> {
    const url =
      env.LINNEO_API_URL_BASE + env.LINNEO_CLASSIFICA_BY_CODICE_ESTESO;

    const filtroDTO = new FiltroRicercaClassificaDTO();
    filtroDTO.cmu = codice;
    filtroDTO.exactMatch = false;
    filtroDTO.countChildren = false;
    filtroDTO.showCancellati = false;
    filtroDTO.dataInferiore = null;
    filtroDTO.dataSuperiore = null;

    console.log(
      "[ClassificaServiceComponent][getClassificaChildrenAsync] filtroDTO:",
      filtroDTO
    );
    console.log(
      "[ClassificaServiceComponent][getClassificaChildrenAsync] url:",
      url
    );
    /* const arrayVoceClassificaVO = await this.httpClient
    .get<VoceClassificaDTO[]>(url, {
      headers: { X_RTSYSID: cfUtente }
    }).toPromise(); */
    const arrayVoceClassificaDTO = await this.httpClient
      .post<VoceClassificaDTO[]>(url, filtroDTO)
      .toPromise();
    return this.mapperVoceClassifica.convertListDtoToVo(arrayVoceClassificaDTO);
  }

  async getStoricoVociClassifica(codice: string): Promise<VoceClassificaVO[]> {
    const url =
      env.LINNEO_API_URL_BASE + env.LINNEO_CLASSIFICA_BY_CODICE_ESTESO;

    const filtroDTO = new FiltroRicercaClassificaDTO();
    filtroDTO.codice = codice;
    filtroDTO.exactMatch = false;
    filtroDTO.countChildren = true;
    filtroDTO.showCancellati = true;
    filtroDTO.dataInferiore = null;
    filtroDTO.dataSuperiore = null;

    console.log(
      "[ClassificaServiceComponent][getStoricoVociClassifica] filtroDTO:",
      filtroDTO
    );
    console.log(
      "[ClassificaServiceComponent][getStoricoVociClassifica] url:",
      url
    );

    const arrayVoceClassificaDTO = await this.httpClient
      .post<VoceClassificaDTO[]>(url, filtroDTO)
      .toPromise();
    return this.mapperVoceClassifica.convertListDtoToVo(arrayVoceClassificaDTO);
  }

  // getClassificaChildrenByListaCodici(
  //     codici: string[],
  //     cfUtente: string,
  //     countChildren: boolean
  // ): Observable<VoceClassificaVO[]> {
  //     console.log("[ClassificaService.getClassificaChildrenByListaCodici] codici:", codici);
  //     console.log("[ClassificaService.getClassificaChildrenByListaCodici] cfUtente:", cfUtente);
  //     console.log("[ClassificaService.getClassificaChildrenByListaCodici] countChildren:", countChildren);
  //     const url = env.LINNEO_API_URL_BASE + env.LINNEO_CLASSIFICA_BY_LISTA_CODICI;
  //     let params: HttpParams;
  //     if (countChildren) {
  //         params = new HttpParams()
  //             .set("countChildren", "true");
  //     } else {
  //         params = new HttpParams()
  //             .set("countChildren", "false");
  //     }

  //     console.log("[ClassificaService.getClassificaChildrenByListaCodici] url:", url);
  //     const listaCodici = new ListaCodiciDTO();
  //     listaCodici.codici = codici;

  //     return this.httpClient
  //         .post(url, listaCodici, { headers: { X_RTSYSID: cfUtente }, params: params })
  //         .pipe(
  //             map((resultList: VoceClassificaDTO[]) =>
  //                 this.mapperVoceClassifica.convertListDtoToVo(resultList)
  //             ),
  //             catchError(_ => Observable.of([]))
  //         );
  // }

  ricerca(filtro: string, cfUtente: string): Observable<VoceClassificaVO[]> {
    let url = env.LINNEO_API_URL_BASE + env.LINNEO_CLASSIFICA_RICERCA;
    url = url + filtro;

    console.log("[ClassificaServiceComponent][ricerca] filtro:", filtro);
    console.log("[ClassificaServiceComponent][ricerca] url:", url);
    return this.httpClient
      .get<VoceClassificaDTO[]>(url, {
        headers: { X_RTSYSID: cfUtente },
      })
      .pipe(
        map(
          (resultList: VoceClassificaDTO[]) =>
            this.mapperVoceClassifica.convertListDtoToVo(resultList)
          // this.mapperVoceClassifica.convertListDtoToVo(this.eliminaVociPrimoLivello(resultList))
        ),
        catchError((_) => Observable.of([]))
      );
  }

  getClassifica(filtro: String): Observable<VoceClassificaVO[]> {
    let url = env.LINNEO_API_URL_BASE + env.LINNEO_CLASSIFICA_RICERCA;

    return this.httpClient.get<VoceClassificaDTO[]>(url + filtro).pipe(
      map((response: VoceClassificaDTO[]) => this.convertDataClass(response)),
      catchError((_) => Observable.of([]))
    );
  }

  private convertDataClass(res: VoceClassificaDTO[]) {
    console.log("[ClassificaServiceComponent][convertDataClass] res:", res);
    console.log(
      "[ClassificaServiceComponent][convertDataClass]numero risultati: " +
        res.length
    );
    let classificheVO: VoceClassificaVO[];
    let appoggioDesc: string;
    classificheVO = new Array<VoceClassificaVO>();
    res.forEach((classificaDTO) => {
      let classificaVO = new VoceClassificaVO();
      classificaVO = this.mapperVoceClassifica.convertDtoToVo(classificaDTO);
      if (classificaVO.nome != null && classificaVO.nome.length > 58) {
        appoggioDesc = classificaVO.nome.substring(0, 58) + "...";
      } else {
        appoggioDesc = classificaVO.nome;
      }
      classificaVO.output = classificaVO.codice + " - " + appoggioDesc;
      classificheVO.push(classificaVO);
    });
    console.log(
      "[ClassificaServiceComponent][convertDataClass] exit",
      classificheVO
    );
    return classificheVO;
  }

  getClassificaByStrutturaCodice(codice: string): Observable<ClassificaVO[]> {
    let url =
      env.LINNEO_API_URL_BASE + env.LINNEO_RICERCA_CLASSIFICA_BY_SETTORE;
    console.log(
      "[classificaServiceCOmponent][getClassificaByStrutturaCodice] codice>>>",
      codice
    );
    console.log(
      "[classificaServiceCOmponent][getClassificaByStrutturaCodice] url:",
      url
    );
    const filtroDTO = new FiltroRicercaClassificaDTO();
    filtroDTO.cmu = codice;
    filtroDTO.exactMatch = false;
    filtroDTO.countChildren = false;
    filtroDTO.showCancellati = false;
    filtroDTO.dataInferiore = null;
    filtroDTO.dataSuperiore = null;
    return this.httpClient.post<VoceClassificaDTO[]>(url, filtroDTO).pipe(
      map(
        (resultList: ClassificaDTO[]) =>
          this.mapperClassifica.convertListDtoToVo(resultList)
        // this.mapperVoceClassifica.convertListDtoToVo(this.eliminaVociPrimoLivello(resultList))
      ),
      catchError((_) => Observable.of([]))
    );
  }

/*   getClassificaById(id: string): Observable<ClassificaVO> {
    let url = env.LINNEO_API_URL_BASE + env.LINNEO_CLASSIFICA + id;

    return this.httpClient.get<ClassificaDTO>(url).pipe(
      map((response) => this.mapperClassifica.convertDtoToVo(response)),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  } */
}
